export class DocumentDetails {
  constructor(
    public dateobtention: Date,
    public documentType: string,
    public etablissement: string,
    public nomdiplome: string
  ) {}
}
